import RouterTabs from '@/gf/components/Layout/RouterTabs'
import Page from '@/gf/components/Page'
import useOrgMachineDetails from '@/gf/hooks/useOrgMachineDetails'
import { Cog6ToothIcon, InformationCircleIcon, RssIcon } from '@heroicons/react/24/outline'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import Frame from '../components/Frame'
import Activity from './MachineDetails/Activity'
import Specs from './MachineDetails/Specs'
import UnitDetails from './MachineDetails/UnitDetails'
import NotFound from './NotFound'
import Parts from './MachineDetails/Parts'
import MachineIcon from '../components/Frame/Icons/MachineIcon'
import OrgMachine from './MachineDetails/OrgMachine'

const MachineDetails = () => {
  const { machineId: id } = useParams<{ machineId: string }>() as { machineId: string }
  const machineDetails = useOrgMachineDetails({ id })
  const machine = machineDetails.data?.orgMachine

  if (machine === null) return <NotFound />

  const title = machine
    ? `${machine?.machine?.make} ${machine?.machine?.model} #${machine.name}`
    : ''

  const breadcrumbs = {
    copy: 'Back to Dashboard',
    crumbs: [
      { name: 'Fleet', href: '/fleet' },
      { name: title, href: `/machines/${id}` },
    ],
  }

  const baseUrl = `/machines/${id}`

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title="Machine Details">
        <div className="space-y-6 pt-6">
          <OrgMachine machineDetails={machineDetails} />
          <RouterTabs
            tabs={[
              { label: 'Activity', path: `${baseUrl}/activity`, icon: RssIcon },
              { label: 'Machine Specs', path: `${baseUrl}/specs`, icon: MachineIcon },
              { label: 'Machine Parts', path: `${baseUrl}/parts`, icon: Cog6ToothIcon },
              {
                label: 'Unit Details',
                path: `${baseUrl}/unit-details`,
                icon: InformationCircleIcon,
              },
            ]}
          >
            <div className="p-4">
              <Routes>
                <Route path="" element={<Navigate to="activity" replace />} />
                <Route path="activity" element={<Activity machineId={id} />} />
                <Route path="parts" element={<Parts orgMachineId={id} />} />
                <Route path="specs" element={<Specs machineDetails={machineDetails} />} />
                <Route
                  path="unit-details"
                  element={<UnitDetails machineDetails={machineDetails} />}
                />
              </Routes>
            </div>
          </RouterTabs>
        </div>
      </Page>
    </Frame>
  )
}

export default MachineDetails
